import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppMenuState } from "./app-menu.state";

export const getAppMenuState = createFeatureSelector<AppMenuState>('AppMenu');

export const selectVisibility = createSelector(getAppMenuState, (state: AppMenuState) => {
    return !!state ? state.visible : null;
});
